myApp.config(function ($translateProvider) {
    $translateProvider.translations('az', {
        BACK: "geri"
    })
});
